import React, {
  CSSProperties,
  Fragment,
  ReactElement,
  useEffect,
  useState,
} from 'react';
import {
  setAppBarTitle,
  setBackNavEnabled,
  setBackNavAction,
} from '../../redux/globalSlice';
import {useHistory, useLocation} from 'react-router-dom';

import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import BarcodeScan from '../storescan/BarcodeScanner';
import StoreCodeMessage from '../storescan/StoreCodeMessage';
import infoIcon from '../../assets/images/infoIcon.svg';
import rightarrow from '../../assets/images/right_arrow_btn.svg';
import {BackButtonAction} from '../../core/utils/string.util';
import {
  getAccessToken,
  getStoreCode,
  getStoreInformation,
  getUser,
} from '../../core/localstorage-data';
import ReactTooltip from 'react-tooltip';
import useWindowDimensions from '../../core/utils/window.utils';
import Lottie from 'react-lottie';
import Tool_Tip_Find_Missing from '../../assets/json/Tool_Tip_Find_Missing.json';
import ErrorToast from '../../components/notifications/ErrorToast';
import cogoToast from 'cogo-toast';
import IteamSearchToast from '../../components/notifications/IteamSearchToast';
import shoppingBagIcon from '../../assets/images/top_nav_shopping_bag.svg';
import RupeesIcon from '../../assets/images/rupees.svg';
import {
  fetchOrder,
  orderResponse,
  checkMMRP,
  mmrpResponse,
  addProduct,
  mmrpError,
  addProductResponse,
  resetMMRPState,
  resetAddproductState,
} from '../../redux/orderSlice';
type BarcodeData = {
  barcode: any;
};
import {
  addToCartEventGA,
  scanBarocodeGtmData,
  setPageName,
} from '../../lib/tagmanager';
import {
  scanCodeEvent,
  eventNames,
  pageName,
  EliteNumericStoreCode,
  EliteAlphaNumStoreCode,
  EliteEnableStatus,
} from '../../lib/constants';
import {producDetailInfo} from '../../lib/types';
import InformationToast from '../../components/notifications/InformationToast';
export interface LocationState {
  pathname: string;
  updatedMMRP: any;
  search: string;
  hash: string;
  key: string;
}
const CheckoutHomePage: React.FC<BarcodeData> = ({
  barcode,
}: BarcodeData): ReactElement => {
  const [canScan, setCanScan] = useState(true);
  useEffect(() => {
    setPageName(pageName.checkoutPage);
  }, []);
  useEffect(() => {
    dispatch(setAppBarTitle('Self checkout'));
    dispatch(setBackNavEnabled(true));
    dispatch(setBackNavAction(BackButtonAction.TO_HOME));
    return () => {
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      dispatch(resetAddproductState());
    };
  }, [setAppBarTitle]);

  const navigate = useHistory();
  const dispatch = useAppDispatch();
  //TBD
  const [enableBarcodeInput, setEnableBarcodeInput] = useState(false);
  const [enteredBarcode, setEnteredbarcode] = useState('');
  //const [scannedBarcode, setScannedBarcode] = useState('');
  const [buttonEnable, setButtonEnable] = useState(false);
  const [closeDemo, setCloseDemo] = useState(true);
  const [scanByCamera, setScanByCamera] = useState(false);
  const orderResp = useAppSelector(orderResponse);
  const addProductResp = useAppSelector(addProductResponse);
  const mmrpResp = useAppSelector(mmrpResponse);
  const mmrpErr = useAppSelector(mmrpError);
  const storeCode = `0${getStoreInformation().store_code}`;
  const card_number = getUser().cardNumber;
  const storeId = getStoreCode();
  const accessToken = getAccessToken();
  const routeState = useLocation<LocationState>().state;

  const [showElite, setShowElite] = useState(false);
  const createGtmEvent = (addedItem: any, eventNameData: string) => {
    let scanEventName = eventNameData;
    if (scanByCamera === true) {
      scanEventName = eventNames.barcodeScanned;
    } else {
      scanEventName = eventNames.searchByBarcode;
    }

    const productGtmDetail: producDetailInfo = {
      scan_Code_Number: addedItem.itemID,
      product_Name: addedItem.itemDesc,
      price: addedItem.priceList[0].extSellPrice.toString(),
      product_ID: addedItem.itemEAN,
      //order_Address_City:string;
      //first_Name: customerProfileData.firstName,
      //last_Name:string,
      //category_Name:string;
      //category_Type:string;
      brand: addedItem.itemBrand,
      size: addedItem.itemSize,
      // stock_Status: variant.stock.stockLevel.toString(),
      eventName: scanEventName,
      event: scanCodeEvent,
    };
    scanBarocodeGtmData(productGtmDetail);
  };

  useEffect(() => {
    if (mmrpResp !== null && mmrpErr !== '') {
      cogoToast.error(
        <InformationToast
          title="Error"
          description="Unable to process your request at this moment, please try again"
        />,
        {
          hideAfter: 2,
          renderIcon: () => {
            return null;
          },
        },
      );
      dispatch(resetMMRPState());
    } else if (!mmrpResp && mmrpErr !== '') {
      cogoToast.error(
        <InformationToast
          title="Error"
          description="Unable to process your request at this moment, please try again"
        />,
        {
          hideAfter: 2,
          renderIcon: () => {
            return null;
          },
        },
      );
      dispatch(resetMMRPState());
    }
    setTimeout(() => {
      setCanScan(true);
    }, 2000);
  }, [mmrpResp, mmrpErr, canScan]);

  useEffect(() => {
    if (orderResp === null) {
      const parameters = {
        accessToken: accessToken,
        payload: {
          storeCode: storeCode,
          cardNumber: card_number,
          storeKeyId: storeId,
        },
      };
      //dispatch orderID api call
      dispatch(fetchOrder(parameters));
    } else {
      // if (orderResp.itemList && orderResp.itemList.length <= 0) {
      //   setOrderID(orderResp.orderId);
      // }
    }
  }, [orderResp]);

  useEffect(() => {
    setCanScan(true);
    if (addProductResp !== null) {
      let addedItem = null;

      if (addProductResp?.statusCode === '200') {
        if (routeState && routeState.updatedMMRP && enteredBarcode === '') {
          addedItem = routeState.updatedMMRP;
        } else {
          if (enteredBarcode) {
            addedItem =
              addProductResp &&
              addProductResp.productList &&
              addProductResp.productList[enteredBarcode];
          } else {
            addedItem =
              addProductResp &&
              addProductResp.productList &&
              addProductResp.productList[
                routeState &&
                  routeState.updatedMMRP &&
                  routeState.updatedMMRP.itemID
              ];
          }
        }
        setTimeout(() => {
          setCanScan(true);
        }, 2000);
        if (addedItem) {
          addToCartEventGA(addedItem);
          createGtmEvent(addedItem, ' ');
          createGtmEvent(addedItem, eventNames.addTObagEvent);
          let scanEventName = '';
          if (scanByCamera === true) {
            scanEventName = eventNames.barcodeScanned;
          } else {
            scanEventName = eventNames.searchByBarcode;
          }

          const productGtmDetail: producDetailInfo = {
            scan_Code_Number: addedItem.itemID,
            product_Name: addedItem.itemDesc,
            price: addedItem.priceList[0].extSellPrice.toString(),
            product_ID: addedItem.itemEAN,
            //order_Address_City:string;
            //first_Name: customerProfileData.firstName,
            //last_Name:string,
            //category_Name:string;
            //category_Type:string;
            brand: addedItem.itemBrand,
            size: addedItem.itemSize,
            // stock_Status: variant.stock.stockLevel.toString(),
            eventName: scanEventName,
            event: scanCodeEvent,
          };
          scanBarocodeGtmData(productGtmDetail);
          navigate.push('/checkout/scan-product', {
            addedItem,
          });

          //need to add code here
          // cogoToast.success(
          //   <IteamSearchToast title="Item has been added to your bag">
          //     <div className="pt-2 ml-4 flex justify-between leading-3">
          //       <div>
          //         <span className="font-medium font-roboto">Max fashion</span>
          //       </div>
          //       <div className="text-right mr-4 flex">
          //         {addedItem.priceList[0].extSellPrice !== null &&
          //         addedItem.priceList[0].sellPrice !==
          //           addedItem.priceList[0].extSellPrice ? (
          //           <div className="flex justify-between items-center">
          //             <strike>
          //               <span className="text-black_zero opacity-30 text-xxs flex justify-start">
          //                 <img src={RupeesIcon} />
          //                 <span className="ml-1">
          //                   {addedItem.priceList[0].sellPrice}
          //                 </span>
          //               </span>
          //             </strike>
          //             <span className="flex ml-1">
          //               <img src={RupeesIcon} />
          //               <span className="ml-1 font-medium">
          //                 {addedItem.priceList[0].extSellPrice}
          //               </span>
          //             </span>
          //           </div>
          //         ) : (
          //           <div>
          //             <span className=" flex ml-1">
          //               {<img src={RupeesIcon} />}{' '}
          //               <span className="ml-1 font-medium">
          //                 {addedItem.priceList[0].sellPrice}
          //               </span>
          //             </span>
          //           </div>
          //         )}
          //       </div>
          //     </div>
          //     <div className="pt-4 ml-4 flex justify-between leading-4">
          //       <div>
          //         <span className="text-small leading-1 text-left font-medium font-roboto text-black_zero">
          //           {addedItem.itemDesc}
          //         </span>
          //       </div>
          //       <div className=" text-right mr-4">
          //         <div>
          //           <span className="text-xxs font-roboto min-w-min">
          //             Colour :<b> {addedItem.itemColour}</b>
          //           </span>
          //         </div>
          //         <div style={{minWidth: '100px'}}>
          //           <span className="text-xxs font-roboto text-left">
          //             Size : <b>{addedItem.itemSize}</b>
          //           </span>
          //         </div>
          //       </div>
          //     </div>
          //     <div className=" ml-4 mt-2 flex justify-between leading-3 pb-4 border-t-1 border-solid border-gray-200">
          //       <div className="flex mt-2">
          //         <img className="mr-2" src={shoppingBagIcon} />
          //         <span className="font-roboto text-xxs mr-2">
          //           Click on your <b>shopping bag</b> to know the final price
          //           post discount or to edit your bag
          //         </span>
          //       </div>
          //       <div className=" text-right mr-4"></div>
          //     </div>
          //   </IteamSearchToast>,
          //   {
          //     hideAfter: 3,
          //     renderIcon: () => {
          //       return null;
          //     },
          //   },
          // );
          dispatch(resetAddproductState());
        }
      } else {
        cogoToast.error(
          <ErrorToast
            title="Error"
            description={
              addProductResp.statusMessage ||
              'Scan barcode to continue to add products to your cart'
            }
          />,
          {
            hideAfter: 5,
            renderIcon: () => {
              return null;
            },
          },
        );
      }
      setEnteredbarcode('');
      dispatch(resetMMRPState());
    }
  }, [addProductResp]);

  useEffect(() => {
    if (orderResp !== null) {
      if (mmrpResp !== null) {
        if (mmrpResp.mmrpFlag === 'N') {
          //call add product api and show notification using productlist
          const parameters = {
            accessToken: getAccessToken(),
            payload: {
              storeCode: storeCode,
              orderId: orderResp.orderId,
              productId: enteredBarcode, // || scannedBarcode,
              selectedPrice: 0,
            },
          };
          dispatch(addProduct(parameters));
        } else if (mmrpResp.mmrpFlag === 'Y') {
          navigate.push('/checkout/match-price');
          //navigate to match the price page
        } else if (mmrpResp.statusCode && mmrpResp.statusCode === '400') {
          cogoToast.error(
            <ErrorToast title="Error" description={mmrpResp.statusMessage} />,
            {
              hideAfter: 2,
              renderIcon: () => {
                return null;
              },
            },
          );
          dispatch(resetMMRPState());
        }
        //setOrderID(orderResp.orderId);
      }
    }
  }, [mmrpResp]);

  const infoTooltip = {
    loop: true,
    autoplay: true,
    animationData: Tool_Tip_Find_Missing,
    rendererSettings: {
      // preserveAspectRatio: "xMidYMid slice"
    },
  };

  useEffect(() => {
    setTimeout(() => {
      setCloseDemo(false);
    }, 2000);
    EliteNumericStoreCode.map(storecode => {
      if (storecode === storeId && EliteEnableStatus === true) {
        setShowElite(true);
      }
    });
    EliteAlphaNumStoreCode.map(storecode => {
      if (storecode === storeId && EliteEnableStatus === true) {
        setShowElite(true);
      }
    });
  }, []);
  const unableScanLinkClick = () => {
    setEnableBarcodeInput(true);
  };
  const buttonHandler = (event: React.SyntheticEvent) => {
    event.preventDefault();
    //barcode(enteredBarcode);
    setCanScan(false);
    if (enteredBarcode === '1000010141944' && showElite === false) {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Elite subscription is currently not available for this store"
        />,
        {
          hideAfter: 4,
          renderIcon: () => {
            return null;
          },
        },
      );
      setTimeout(() => {
        setCanScan(true);
      }, 2000);
    } else {
      if (orderResp !== null) {
        const parameters = {
          accessToken: accessToken,
          payload: {
            storeCode: storeCode,
            orderId: orderResp.orderId,
            productId: enteredBarcode,
          },
        };
        dispatch(checkMMRP(parameters));
      }
    }
  };

  const handleInputChange = (e: {
    target: {value: React.SetStateAction<string>};
  }) => {
    setEnteredbarcode(e.target.value);

    if (e.target.value.length === 4) {
      setButtonEnable(true);
    } else {
      setButtonEnable(false);
    }
  };

  function handleScan(scannedBarcode: string) {
    setCanScan(false);
    if (scannedBarcode === '1000010141944' && showElite === true) {
      cogoToast.error(
        <ErrorToast
          title="Error"
          description="Elite subscription is currently not available for this store"
        />,
        {
          hideAfter: 4,
          renderIcon: () => {
            return null;
          },
        },
      );
      setTimeout(() => {
        setCanScan(true);
      }, 2000);
    } else {
      setScanByCamera(true);

      setEnteredbarcode(scannedBarcode);
      if (orderResp !== null) {
        const parameters = {
          accessToken: accessToken,
          payload: {
            storeCode: storeCode,
            orderId: orderResp.orderId,
            productId: scannedBarcode,
          },
        };

        dispatch(checkMMRP(parameters));
      }
    }
  }

  const {width} = useWindowDimensions();

  const cameraViewHeight = width - 32 * 2;
  const cameraViewEdgeBoxHeight = cameraViewHeight - (2 * cameraViewHeight) / 3;
  const boxStyles: CSSProperties = {
    height: `${cameraViewEdgeBoxHeight}px`,
    width: `${cameraViewEdgeBoxHeight}px`,
    borderColor: '#d83f38',
  };
  return (
    <Fragment>
      <div className="text-center bg-blue_three child-container relative p-4">
        <div className="absolute barcode-overlay-content bottom-0 flex flex-col left-0 right-0 top-0 z-10">
          <div className="flex-grow bg-black_two ">
            <StoreCodeMessage
              title1={'Scan product barcode'}
              title2={'to add to bag '}
            />
          </div>

          <div className="scanner-container">
            <div className="corners">
              <div className="tops lefts">&nbsp;</div>
              <div className="tops rights">&nbsp;</div>
              <div className="bottoms rights">&nbsp;</div>
              <div className="bottoms lefts">&nbsp;</div>
              <BarcodeScan onScan={handleScan} canScan={canScan} />
            </div>
          </div>

          <div
            className="w-full border-1 bg-black_two  text-opacity-50    mt-4"
            style={{color: 'rgb(26, 26, 26,0.5)'}}></div>
          <div className="flex-grow bg-blue_two">
            {enableBarcodeInput ? (
              <div className=" px-12">
                <div className=" mb-4 mt-4 mx-auto">
                  <div></div>
                  <div>
                    <span className="text-small leading-18 text-center font-roboto text-black_zero">
                      Unable to scan barcode
                    </span>
                  </div>
                </div>
                <form onSubmit={buttonHandler}>
                  <div className="flex items-center mb-6">
                    <div className=" flex flex-col h-50 rounded-lg bg-blue_four w-full">
                      <div className="flex">
                        <div className="z-50 -mt-2 -ml-1">
                          <div data-tip data-for="registerTip">
                            <img
                              className="h-6 bg-white rounded-full"
                              src={infoIcon}
                            />
                          </div>
                          <div>
                            <ReactTooltip
                              id="registerTip"
                              place="top"
                              effect="solid"
                              event="click"
                              backgroundColor="white"
                              clickable={true}
                              textColor="black"
                              className="-left-20 top-48 w-64 h-52">
                              <Lottie options={infoTooltip} />
                            </ReactTooltip>
                          </div>
                        </div>

                        <div>
                          <span className="font-bold text-xs font-roboto">
                            Product barcode
                          </span>
                        </div>
                      </div>
                      <input
                        type="number"
                        className="w-full bg-blue_four focus:outline-none font-roboto ml-4  "
                        placeholder="Enter product barcode"
                        value={enteredBarcode}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="">
                      <button
                        onClick={buttonHandler}
                        className=" h-50 focus:outline-none font-bold normal primary arrow rounded-r-lg text-white w-12 flex items-center justify-center"
                        disabled={
                          enteredBarcode.length < 8 ||
                          enteredBarcode.length > 17
                        }>
                        <img src={rightarrow} alt="button" />
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            ) : (
              <div className="mt-11">
                <a
                  className=" text-red_zero font-bold  font-roboto"
                  onClick={unableScanLinkClick}>
                  Unable to scan ?
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default CheckoutHomePage;
